// Layout Types
import { DefaultLayout, SignOutLayout, PublicLayout } from "./layouts";

// Route containers
import Starter from "./containers/pages/Auth/starter";
import signUp from "./containers/pages/Auth/signUp";
import signIn from "./containers/pages/Auth/signIn";
import Welcome from "./containers/pages/Auth/welcome";
import ServiceAgree from "./containers/pages/Auth/serviceAgree";
import PrivateAgree from "./containers/pages/Auth/privateAgree";

import cafe from "./containers/pages/Auth/cafe";
import cafeInAppOrderReturnUrl from "./containers/pages/Auth/cafeInAppOrderReturnUrl";
import cafeMsgOrderReturnUrl from "./containers/pages/Auth/cafeMsgOrderReturnUrl";

import Dashboard from "./containers/pages/Dashboard/dashboard";

import ReviewList from "./containers/pages/Review/reviewList";
import ReviewMileage from "./containers/pages/Review/reviewMileage";
import ReviewWrite from "./containers/pages/Review/reviewWrite";
import ReviewMassWrite from "./containers/pages/Review/reviewMassWrite";
import ReviewMassList from "./containers/pages/Review/reviewMassList";
import ReviewCopy from "./containers/pages/Review/reviewCopy";
import ReviewCopyHistory from "./containers/pages/Review/reviewCopyHistory";
import SnsFeed from "./containers/pages/Review/SnsFeed";

import ReplyByProductList from "./containers/pages/Review/replyByProductList";
import ReviewWriteConfigByProduct from "./containers/pages/Review/reviewWriteConfigByProduct";
import ReviewGroup from "./containers/pages/Review/reviewGroup";
import ReviewGroupReviews from "./containers/pages/Review/reviewGroupReviews";
import SurveyReviewConfig from "./containers/pages/Review/surveyReviewConfig";
import QuickReviewConfig from "./containers/pages/Review/quickReviewConfig";
import SurveyStats from "./containers/pages/Review/surveyStats";
import ReviewGuide from "./containers/pages/Review/reviewGuide";

import EasySetting from "./containers/pages/Review/easySetting";
import ReplyWriteConfig from "./containers/pages/Review/replyWriteConfig";
import ReviewWriteConfig from "./containers/pages/Review/reviewWriteConfig";
import MileageConfig from "./containers/pages/Review/mileageConfig";
import ReviewFilter from "./containers/pages/Review/reviewFilter";

import widgetByPage from "./containers/pages/Widget/widgetByPage";
import WidgetAnalytics from "./containers/pages/Widget/widgetAnalytics";
import WidgetList from "./containers/pages/Widget/widgetList";
import ShortFormWidget from "./containers/pages/Widget/shortFormWidget";
import Labeling from "./containers/pages/Widget/labeling";
import productWidgetList from "./containers/pages/Widget/productWidgetList";
import TotalAiWidget from "./containers/pages/Widget/totalAiWidget";

import KakaoMsgSetting from "./containers/pages/ReviewBooster/kakaoMsgSetting";
import MsgList from "./containers/pages/ReviewBooster/msgList";
import ReviewableListWidget from "./containers/pages/ReviewBooster/reviewableListWidget";

import PopularProducts from "./containers/pages/OrderBooster/popularProducts";
import MainDisplay from "./containers/pages/OrderBooster/mainDisplay";
import PopularDisplay from "./containers/pages/OrderBooster/popularDisplay";
import IntegratedMessage from "./containers/pages/OrderBooster/integratedMessage";
import FreeShippingWidget from "./containers/pages/OrderBooster/freeShippingWidget";

import Banner from "./containers/pages/Design/banner";
import Popup from "./containers/pages/Design/popup";
import BgRemover from "./containers/pages/Design/bgRemover";
import MyImages from "./containers/pages/Design/myImages";
import SeoAudit from "./containers/pages/Design/seoAudit";
import SeoProductList from "./containers/pages/Design/seoProductList";
import ReviewToInsta from "./containers/pages/Design/reviewToInsta";
import ReviewToVideo from "./containers/pages/Design/reviewToVideo";
import BlogList from "./containers/pages/Blog/blogList";
import BlogConfig from "./containers/pages/Blog/blogConfig";

import GoodsList from "./containers/pages/goods/goodsList";

import TeamUserInfoEdit from "./containers/pages/Store/teamUserInfoEdit";
import CompanyInfoEdit from "./containers/pages/Store/companyInfoEdit";
import InAppOrder from "./containers/pages/Store/inAppOrder";
import OrderEnd from "./containers/pages/Store/orderEnd";
import InAppOrderList from "./containers/pages/Store/inAppOrderList";
import MsgOrder from "./containers/pages/Store/msgOrder";
import MsgOrderList from "./containers/pages/Store/msgOrderList";

import AdminMonitor from "./containers/pages/SuperAdmin/adminMonitor";
import AdminUsageDashboard from "./containers/pages/SuperAdmin/adminUsageDashboard";
import OrderReviewPattern from "./containers/pages/SuperAdmin/orderReviewPattern";
import WebhookDashboard from "./containers/pages/SuperAdmin/webhookDashboard";
import LoginNoticePopup from "./containers/pages/SuperAdmin/loginNoticePopup";
import AllStoreList from "./containers/pages/SuperAdmin/allStoreList";
import StoreDataCounts from "./containers/pages/SuperAdmin/storeDataCounts";
import NotificationSend from "./containers/pages/SuperAdmin/notificationSend";
import NotificationKakaoTemplate from "./containers/pages/SuperAdmin/notificationKakaoTemplate";
import AligoSmsSend from "./containers/pages/SuperAdmin/aligoSmsSend";
import ShopList from "./containers/pages/SuperAdmin/shopList";
import StoreList from "./containers/pages/SuperAdmin/storeList";
import StoreFnList from "./containers/pages/SuperAdmin/storeFnList";
import SuperConfigPayment from "./containers/pages/SuperAdmin/superConfigPayment";
import StoreOrderList from "./containers/pages/SuperAdmin/storeOrderList";
import StoreMsgOrderList from "./containers/pages/SuperAdmin/storeMsgOrderList";
import InstallationRequestList from "./containers/pages/SuperAdmin/InstallationRequestList";
import InquiryList from "./containers/pages/SuperAdmin/InquiryList";
import QnAList from "./containers/pages/SuperAdmin/QnAList";
import AiKeywordList from "./containers/pages/SuperAdmin/aiKeywordList";
import EmailHistoryList from "./containers/pages/SuperAdmin/emailHistoryList";
import BankTransferList from "./containers/pages/SuperAdmin/bankTransferList";
import ShopMileage from "./containers/pages/SuperAdmin/shopMileage";
import DataMigration from "./containers/pages/SuperAdmin/dataMigration";
import AnalysisReport from "./containers/pages/SuperAdmin/analysisReport";
import InstallationRequest from "./containers/pages/Board/InstallationRequest";
import Inquiry from "./containers/pages/Board/Inquiry";
import QnA from "./containers/pages/Board/QnA";
import MyBoard from "./containers/pages/Board/MyBoard";

import SnsSetting from "./containers/pages/Sns/SnsSetting";
import SnsCallback from "./containers/pages/Sns/SnsCallback";
import InstagramFeed from "./containers/pages/Sns/InstagramFeed";

// 비로그인 마케팅 페이지
import IntroIndex from "./containers/pages/Intro/IntroIndex";
import IntroCategory from "./containers/pages/Intro/IntroCategory";

// Route Views
import Errors from "./views/Errors";




// src/stores/Common.js의 name값 참고
export default [
  {
    path: "/",
    exact: true,
    layout: SignOutLayout,
    component: Starter
  },
  // === 비로그인 마케팅 페이지 (PublicLayout) ===
  {
    path: "/intro",
    exact: true,
    layout: PublicLayout,
    info: { mainMenu: 'public', subMenu: 'introIndex' },
    component: IntroIndex
  },
  {
    path: "/intro/:slug",
    layout: PublicLayout,
    info: { mainMenu: 'public', subMenu: 'introCategory' },
    component: IntroCategory
  },
  {
    path: "/cafe24",
    layout: SignOutLayout,
    component: cafe
  },
  {
    path: "/cafeRedirect",
    layout: SignOutLayout,
    component: cafe
  },
  {
    path: "/cafeInAppOrderReturnUrl",
    layout: SignOutLayout,
    component: cafeInAppOrderReturnUrl
  },
  {
    path: "/cafeMsgOrderReturnUrl",
    layout: SignOutLayout,
    component: cafeMsgOrderReturnUrl
  },
  {
    path: "/signUp",
    layout: PublicLayout,
    info: { mainMenu: 'public', subMenu: 'signUp' },
    component: signUp
  },
  {
    path: "/signIn",
    layout: PublicLayout,
    info: { mainMenu: 'public', subMenu: 'signIn' },
    component: signIn
  },
  {
    path: "/welcome",
    layout: SignOutLayout,
    component: Welcome
  },
  {
    path: "/serviceAgree",
    layout: SignOutLayout,
    component: ServiceAgree
  },
  {
    path: "/privateAgree",
    layout: SignOutLayout,
    component: PrivateAgree
  },
  {
    path: "/dashboard",
    layout: DefaultLayout,
    info: {mainMenu: 'monitor', subMenu: 'dashboard'},
    component: Dashboard
  },
  //리뷰
  {
    path: "/reviewList",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewList'},
    component: ReviewList
  },
  {
    path: "/reviewMileage",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'reviewMileage'},
    component: ReviewMileage
  },
  {
    path: "/reviewWrite",
    layout: DefaultLayout,
    info: {mainMenu: 'reviewWriteGroup', subMenu: 'reviewWrite'},
    component: ReviewWrite
  },
  {
    path: "/reviewMassWrite",
    layout: DefaultLayout,
    info: {mainMenu: 'reviewWriteGroup', subMenu: 'reviewMassWrite'},
    component: ReviewMassWrite
  },
  {
    path: "/reviewMassList",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewMassList'},
    component: ReviewMassList
  },
  {
    path: "/reviewCopy",
    layout: DefaultLayout,
    info: {mainMenu: 'reviewWriteGroup', subMenu: 'reviewCopy'},
    component: ReviewCopy
  },
  {
    path: "/reviewCopyHistory",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewCopyHistory'},
    component: ReviewCopyHistory
  },
  {
    path: "/snsFeed",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'snsFeed'},
    component: SnsFeed
  },
  {
    path: "/quickReviewConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'quickReviewConfig'},
    component: QuickReviewConfig
  },
  {
    path: "/surveyReviewConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'surveyReviewConfig'},
    component: SurveyReviewConfig
  },
  {
    path: "/surveyStats",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'surveyStats'},
    component: SurveyStats
  },
  //리뷰작성유도
  {
    path: "/kakaoMsgSetting",
    layout: DefaultLayout,
    info: {mainMenu: 'booster', subMenu: 'kakaoMsgSetting'},
    component: KakaoMsgSetting
  },
  {
    path: "/msgList",
    layout: DefaultLayout,
    info: {mainMenu: 'booster', subMenu: 'msgList'},
    component: MsgList
  },
  {
    path: "/reviewableListWidget",
    layout: DefaultLayout,
    info: {mainMenu: 'booster', subMenu: 'reviewableListWidget'},
    component: ReviewableListWidget
  },
  //주문유도
  {
    path: "/popularProducts",
    layout: DefaultLayout,
    info: {mainMenu: 'orderBooster', subMenu: 'popularProducts'},
    component: PopularProducts
  },
  {
    path: "/mainDisplay",
    layout: DefaultLayout,
    info: {mainMenu: 'orderBooster', subMenu: 'mainDisplay'},
    component: MainDisplay
  },
  {
    path: "/popularDisplay",
    layout: DefaultLayout,
    info: {mainMenu: 'orderBooster', subMenu: 'popularDisplay'},
    component: PopularDisplay
  },
  {
    path: "/integratedMessage",
    layout: DefaultLayout,
    info: {mainMenu: 'orderBooster', subMenu: 'integratedMessage'},
    component: IntegratedMessage
  },
  {
    path: "/freeShippingWidget",
    layout: DefaultLayout,
    info: {mainMenu: 'orderBooster', subMenu: 'freeShippingWidget'},
    component: FreeShippingWidget
  },
  //설정
  {
    path: "/reviewWriteConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewWriteConfig'},
    component: ReviewWriteConfig
  },

  {
    path: "/mileageConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'mileageConfig'},
    component: MileageConfig
  },
  {
    path: "/reviewGroup",
    layout: DefaultLayout,
    info: {mainMenu: 'reviewWriteGroup', subMenu: 'reviewGroup'},
    component: ReviewGroup
  },
  {
    path: "/reviewGroupReviews",
    layout: DefaultLayout,
    info: {mainMenu: 'reviewWriteGroup', subMenu: 'reviewGroup'},
    component: ReviewGroupReviews
  },
  {
    path: "/reviewFilter",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'reviewFilter'},
    component: ReviewFilter
  },
  {
    path: "/easySetting",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'easySetting'},
    component: EasySetting
  },
  {
    path: "/replyWriteConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'replyWriteConfig'},
    component: ReplyWriteConfig
  },
  {
    path: "/replyByProductList",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'replyByProductList'},
    component: ReplyByProductList
  },
  {
    path: "/reviewWriteConfigByProduct",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewWriteConfigByProduct'},
    component: ReviewWriteConfigByProduct
  },
  {
    path: "/reviewGuide",
    layout: DefaultLayout,
    info: {mainMenu: 'review', subMenu: 'reviewGuide'},
    component: ReviewGuide
  },
  //SNS
  {
    path: "/snsSetting",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'snsSetting'},
    component: SnsSetting
  },
  {
    path: "/myInstagramFeed",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'snsSetting'},
    component: InstagramFeed
  },
  {
    path: "/instagram_callback",
    layout: SignOutLayout,
    component: SnsCallback
  },
  {
    path: "/facebook_callback",
    layout: SignOutLayout,
    component: SnsCallback
  },
  {
    path: "/naver_callback",
    layout: SignOutLayout,
    component: SnsCallback
  },
  {
    path: "/youtube_callback",
    layout: SignOutLayout,
    component: SnsCallback
  },
  //관리자
  {
    path: "/teamUserInfo",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'teamUserInfo'},
    component: TeamUserInfoEdit
  },
  {
    path: "/companyInfo",
    layout: DefaultLayout,
    info: {mainMenu: 'settings', subMenu: 'reviewList'},
    component: CompanyInfoEdit
  },
  //위젯 Labeling
  {
    path: "/widgetByPage",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'widgetByPage'},
    component: widgetByPage
  },
  {
    path: "/widgetAnalytics",
    layout: DefaultLayout,
    info: {mainMenu: 'monitor', subMenu: 'widgetAnalytics'},
    component: WidgetAnalytics
  },
  {
    path: "/widgetList",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'widgetList'},
    component: WidgetList
  },
  {
    path: "/shortFormWidget",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'shortFormWidget'},
    component: ShortFormWidget
  },
  {
    path: "/labeling",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'labeling'},
    component: Labeling
  },
  {
    path: "/productWidgetList",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'productWidgetList'},
    component: productWidgetList
  },
  {
    path: "/totalAiWidget",
    layout: DefaultLayout,
    info: {mainMenu: 'widget', subMenu: 'totalAiWidget'},
    component: TotalAiWidget
  },

  //디자인
  {
    path: "/banner",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'banner'},
    component: Banner
  },
  {
    path: "/popup",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'popup'},
    component: Popup
  },
  {
    path: "/reviewToInsta",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'reviewToInsta'},
    component: ReviewToInsta
  },
  {
    path: "/reviewToVideo",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'reviewToVideo'},
    component: ReviewToVideo
  },
  {
    path: "/bgRemover",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'bgRemover'},
    component: BgRemover
  },
  {
    path: "/myImages",
    layout: DefaultLayout,
    info: {mainMenu: 'design', subMenu: 'myImages'},
    component: MyImages
  },
  {
    path: "/blogList",
    layout: DefaultLayout,
    info: {mainMenu: 'blog', subMenu: 'blogList'},
    component: BlogList
  },
  {
    path: "/blogConfig",
    layout: DefaultLayout,
    info: {mainMenu: 'blog', subMenu: 'blogConfig'},
    component: BlogConfig
  },
  {
    path: "/seoAudit",
    layout: DefaultLayout,
    info: {mainMenu: 'seo', subMenu: 'seoAudit'},
    component: SeoAudit
  },
  {
    path: "/seoProductList",
    layout: DefaultLayout,
    info: {mainMenu: 'seo', subMenu: 'seoProductList'},
    component: SeoProductList
  },
  //상품
  {
    path: "/goodsList",
    layout: DefaultLayout,
    info: {mainMenu: 'goods'},
    component: GoodsList
  },



  //리뷰 작성 설정


  //주문
  {
    path: "/inAppOrder",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'inAppOrder'},
    component: InAppOrder
  },
  {
    path: "/orderEnd",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'inAppOrder'},
    component: OrderEnd
  },
  {
    path: "/inAppOrderList",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'inAppOrderList'},
    component: InAppOrderList
  },
  {
    path: "/msgOrder",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'msgOrder'},
    component: MsgOrder
  },
  {
    path: "/msgOrderList",
    layout: DefaultLayout,
    info: {mainMenu: 'payment', subMenu: 'msgOrderList'},
    component: MsgOrderList
  },




  // 슈퍼관리자 메뉴

  {
    path: "/adminMonitor",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'adminMonitor'},
    component: AdminMonitor
  },
  {
    path: "/adminUsageDashboard",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'adminUsageDashboard'},
    component: AdminUsageDashboard
  },
  {
    path: "/orderReviewPattern",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'orderReviewPattern'},
    component: OrderReviewPattern
  },
  {
    path: "/webhookDashboard",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'webhookDashboard'},
    component: WebhookDashboard
  },
  {
    path: "/loginNoticePopup",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'loginNoticePopup'},
    component: LoginNoticePopup
  },
  {
    path: "/notificationSend",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'notificationSend'},
    component: NotificationSend
  },
  {
    path: "/notificationKakaoTemplate",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'notificationSend'},
    component: NotificationKakaoTemplate
  },
  {
    path: "/aligoSmsSend",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'aligoSmsSend'},
    component: AligoSmsSend
  },
  {
    path: "/allStoreList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'allStoreList'},
    component: AllStoreList
  },
  {
    path: "/storeDataCounts",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'storeDataCounts'},
    component: StoreDataCounts
  },
  {
    path: "/shopList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'shopList'},
    component: ShopList
  },
  {
    path: "/storeList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'storeList'},
    component: StoreList
  },
  {
    path: "/aiKeywordList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'aiKeywordList'},
    component: AiKeywordList
  },
  {
    path: "/storeFnList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'storeFnList'},
    component: StoreFnList
  },
  {
    path: "/superConfigPayment",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'superConfigPayment'},
    component: SuperConfigPayment
  },
  {
    path: "/storeOrderList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'storeOrderList'},
    component: StoreOrderList
  },
  {
    path: "/storeMsgOrderList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'storeMsgOrderList'},
    component: StoreMsgOrderList
  },
  {
    path: "/installationRequests",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'installationRequests'},
    component: InstallationRequestList
  },
  {
    path: "/inquiryList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'inquiryList'},
    component: InquiryList
  },
  {
    path: "/qnaList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'qnaList'},
    component: QnAList
  },
  {
    path: "/emailHistoryList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'emailHistoryList'},
    component: EmailHistoryList
  },
  {
    path: "/bankTransferList",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'bankTransferList'},
    component: BankTransferList
  },
  {
    path: "/shopMileage",
    layout: DefaultLayout,
    info: {mainMenu: 'aoa', subMenu: 'shopMileage'},
    component: ShopMileage
  },
  {
    path: "/dataMigration",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'dataMigration'},
    component: DataMigration
  },
  {
    path: "/analysisReport",
    layout: DefaultLayout,
    info: {mainMenu: 'aoaMonitor', subMenu: 'analysisReport'},
    component: AnalysisReport
  },
  {
    path: "/installationRequest",
    layout: DefaultLayout,
    info: {mainMenu: 'board', subMenu: 'installationRequest'},
    component: InstallationRequest
  },
  {
    path: "/inquiry",
    layout: DefaultLayout,
    info: {mainMenu: 'board', subMenu: 'inquiry'},
    component: Inquiry
  },
  {
    path: "/qna",
    layout: DefaultLayout,
    info: {mainMenu: 'board', subMenu: 'qna'},
    component: QnA
  },
  {
    path: "/myBoard",
    layout: DefaultLayout,
    info: {mainMenu: 'board', subMenu: 'myBoard'},
    component: MyBoard
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
];
